import { IndicatorStatus } from "@lib/logic";
import { FlexCol, FlexRow, P, Subtitle } from "@quarks";
import { IconNames } from "mapiq-atoms";
import { ScheduleDataIcon } from "src/components/molecules/ScheduleDataIcon";

export type MeetingRoomScheduleDataProps = {
  "data-testid": string;
  status: IndicatorStatus | undefined;
  title?: string;
  subtitle?: string;
  icon: IconNames;
};

export const MeetingRoomScheduleData = ({ status, subtitle, title, icon, ...props }: MeetingRoomScheduleDataProps) => {
  return (
    <FlexRow
      justifyContent="flex-start"
      alignItems="center"
      gap={16}>
      <ScheduleDataIcon
        data-testid={`${props["data-testid"]}`}
        icon={icon}
        status={status}
      />
      <FlexCol>
        <P fontWeight="bold">{title}</P>
        <Subtitle>{subtitle}</Subtitle>
      </FlexCol>
    </FlexRow>
  );
};
